import { render, staticRenderFns } from "./Electrocardiogram.vue?vue&type=template&id=005d6466&scoped=true"
import script from "./Electrocardiogram.vue?vue&type=script&lang=js"
export * from "./Electrocardiogram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d6466",
  null
  
)

export default component.exports